import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import  { ImportProductView } from "./importProduct-view"
import { PurchaseProcessViewModel, RequestPurchaseProcessCompareMessage } from "./purchaseProcess/purchaseProcess-viewModel";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IImportingPart } from "./ipart";
import { InquiryListViewModel } from "./bills/inquiryList/inquiryList-viewModel";
import { QuotationListViewModel } from "./bills/quotationList/quotationList-viewModel";
import { PreOrderListViewModel } from "./bills/preOrderList/preOrderList-viewModel";
import { InvoicesListViewModel } from "./bills/invoicesList/invoicesList-viewModel";
import { InWayViewModel } from "./bills/inWay/inWay-viewModel";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { Converters } from "src/converters";
import { downloadFile, exportToCsv } from "src/uicomponents/components/utilities";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { CarBrandSelectorViewModel } from "src/Warehouse/carBrandManipulation/carBrandManipulation-viewModel";

export class ImportProductViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'بازرگانی';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.saleTo = moment.utc();
        this.purchaseProcessSelector = new PurchaseProcessViewModel(this);
        this.parts = ObservableArray.create<IImportingPart>();
        this.parts.update(...[
            new InquiryListViewModel(this),
            new QuotationListViewModel(this),
            new PreOrderListViewModel(this),
            new InWayViewModel(this),
            new InvoicesListViewModel(this),
        ]);
        this.selectedPart = this.parts.at(0);

        this.purchaseProcessSelector.onProcessSelectionChanged = x=>{
            this.loadSelectedPartData();
        };
    }
    GetDefaultView(): View <ViewModel> {
        return new ImportProductView();
    }
    public getTypeId(): string {
        return "VM-01ABCA07-C32D-4B69-BF27-109B0870F31A"
    }

    public set purchaseProcessSelector(v: PurchaseProcessViewModel) { this._purchaseProcessSelector = v; } public get purchaseProcessSelector(): PurchaseProcessViewModel { return this._purchaseProcessSelector;} private _purchaseProcessSelector: PurchaseProcessViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set saleTo(v: moment.Moment) { this._saleTo = v; } public get saleTo(): moment.Moment { return this._saleTo;} private _saleTo: moment.Moment;
    
    public set parts(v: ObservableArray<IImportingPart>) { this._parts = v; } public get parts(): ObservableArray<IImportingPart> { return this._parts;} private _parts: ObservableArray<IImportingPart>;
    public set selectedPart(v: IImportingPart) { 
        this._selectedPart = v; 
        this.loadSelectedPartData();
        
    } public get selectedPart(): IImportingPart { return this._selectedPart;} private _selectedPart: IImportingPart;
    
    public handleMessage(message: ViewModelMessage) {
        if(message instanceof RequestPurchaseProcessCompareMessage){
            this.compare(message.singleProcessId,message.code);
        }else{
            return super.handleMessage(message);
        }
    }
    async compare(processId:string,code:string){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/GetComparison',{
                ToSaleUntil : this.saleTo.clone().hour(23).minute(59).second(59),
                ProcessId : processId
            });
            if(result.IsSuccessful){
                downloadFile(result.ExcelData,`گزارش مقایسه ${code}.xlsx`);
            }else{
                this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            }
        } catch (ex) {
            this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async analyze(){
        try {
            this.isLoading = true;
            let analyze = new Analyze(this, this.saleTo);
            this.showPopup(analyze);
            
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    loadSelectedPartData(){
        if(this.selectedPart!=null && this.purchaseProcessSelector.selectedProcess!=null){
            this.selectedPart.load(this.purchaseProcessSelector.selectedProcess.id);
        }
    }
}

export class Analyze extends ViewModel implements IPopup{
    
    public getTypeId(): string {return 'analyze';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ImportProductViewModel, from: moment.Moment) {
        super(parent);
        this.saleTo = from;
        this.carBrandSelector = new CarBrandSelectorViewModel(this);
    }
    closePopup() {}

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set saleTo(v: moment.Moment) { this._saleTo = v; } public get saleTo(): moment.Moment { return this._saleTo;} private _saleTo: moment.Moment;
    public set carBrandSelector(v: CarBrandSelectorViewModel) { this._carBrandSelector = v; } public get carBrandSelector(): CarBrandSelectorViewModel { return this._carBrandSelector;} private _carBrandSelector: CarBrandSelectorViewModel;

    async confirm(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/PredictImport',{
                ToSaleUntil : this.saleTo.clone().hour(23).minute(59).second(59),
                CarBrandId : this.carBrandSelector.selectedItem.id
            });
            exportToCsv(`گزارش آنالیز واردات.csv`, result.Predictions.map((x,i)=>{
                return {
                    'ردیف':i+1,
                    'PNC':x.Pnc,
                    'کد خودرو':x.CarCode,
                    'نام خودرو':x.CarName,
                    'مدلهای خودرو' : x.ModelName,
                    'تعداد مدل خودرو' : x.CarModelCount,
                    'شماره فنی':x.ProductCode,
                    'وضعیت':x.NeverOrder==null?'':(x.NeverOrder?'NO':'EO'),
                    'برند':x.Brand,
                    'نام':x.ProductName,
                    'شناسه':x.ProductIndex,
                    'کدهای معادل':x.PartNumberReplaceables,
                    'میزان خرید':x.PurchaseAmount,
                    'میزان خرید دو سال گذشته':x.PurchaseLastTwoYearsAmount,
                    'میزان خرید شش ماه گذشته':x.PurchaseLastSixMonthsAmount,
                    'میزان فروش دو سال گذشته':x.SaleLastTwoYearsAmount,
                    'میزان فروش شش ماه گذشته':x.SaleLastSixMonthsAmount,
                    'میزان فروش':x.TotalAmount,
                    'میزان فاکتور':x.SaleAmount,
                    'میزان مرجوعی':x.ReturnAmount,
                    'میزان کنسلی':x.CancelAmount,
                    'مجموع موجودی PNC':x.PncBalance,
                    'مجموع هانت PNC':x.PncHuntAmount,
                    'مجموع فروش PNC':x.PncSaleAmount,
                    'میزان هانت پیش از اتمام موجودی':x.HuntAmountBeforeFinishing,
                    'میزان هانت پس از اتمام موجودی':x.HuntAmountAfterFinishing,
                    'میزان هانت':x.AllHuntAmount,
                    'موجودی اولیه':x.InitialBalance,
                    'موجودی':x.Balance,
                    'موجودی از ابتدای بازه':x.BalanceAtStartOfPeriod,
                    'نسبت هانت بدون موجودی':x.NoBalanceHuntRatio,
                    'نسبت فروش به هانت دارای موجودی':x.HuntWithBalanceToSaleRatio,
                    'نسبت فروش به موجودی اولیه':x.SaleToInitialBalance,
                    'پیش بینی فروش':x.PredictionAmount,
                    'مورد نیاز' : x.Required,
                    'رقابتی' : x.IsCompeting ? 'بلی' : 'خیر',
                    'set' : x.SetPrice==null ? '' : x.SetPrice,
                    'تاریخ تنظیم set' : x.SetPriceAt==null ? '' : new Converters().persianDateConverterNoTime(x.SetPriceAt),
                    'حداقل قیمت':x.MinPrice,
                    'حداکثر قیمت':x.MaxPrice,
                    'در راه':x.InWayAmount,
                    'درصد سود ده فروش آخر ':x.LastTenDaysSaleBenefitRate,
                    'مینیمم درصد سود':x.MinBenefitPercentage,
                    'موجودی کالاهای مشابه':x.ReplacementProductBalances
                }
            }));
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess('گزارش آنالیز صادر شد','آنالیز');
                this.closePopup();
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }    
}
